import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AppState } from '../store.types';
import { PublishedBoardState } from './published-boards.types';
import { PublishedBoardsModule } from './published-boards-modules';

export const selectPublishedBoardsState = createFeatureSelector<AppState['publishedBoards']>('publishedBoards');

export const selectPublishedBoard = (boardId: string) => {
  return createSelector(selectPublishedBoardsState, (publishedBoardsState) => {
    return publishedBoardsState[boardId];
  });
};

export const selectPublishedBoardData = (boardId: string) => {
  return createSelector(
    selectPublishedBoardsState,
    (publishedBoardsState) => (<PublishedBoardState>publishedBoardsState[boardId])?.data
  );
};
export const selectPublishedBoardModuleData = (boardId: string, module: PublishedBoardsModule) => {
  return createSelector(
    selectPublishedBoardsState,
    (publishedBoardsState) => (<PublishedBoardState>publishedBoardsState[boardId])?.moduleData[module]
  );
};
